var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Print",
    clipPath: "url(#clip0_2741_141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.6667 13.3333H8.33334C5.56667 13.3333 3.33334 15.5667 3.33334 18.3333V28.3333H10V35H30V28.3333H36.6667V18.3333C36.6667 15.5667 34.4333 13.3333 31.6667 13.3333ZM26.6667 31.6667H13.3333V23.3333H26.6667V31.6667ZM31.6667 20C30.75 20 30 19.25 30 18.3333C30 17.4167 30.75 16.6667 31.6667 16.6667C32.5833 16.6667 33.3333 17.4167 33.3333 18.3333C33.3333 19.25 32.5833 20 31.6667 20ZM30 5H10V11.6667H30V5Z",
    fill: "#FFFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2741_141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print_icon.a36bb7c60f78423e44c654345c1f7172.svg";
export { ForwardRef as ReactComponent };